<template>
  <div class="mainpage">
    <div class="head">
      <div class="head-title">我的请假</div>
      <div class="retutnbt" @click="toback">返回</div>
    </div>
    <div class="line"></div>
    <div class="maincontain">
      <div class="searchcontain">
        <div class="left">
          <div class="contain">
            <div class="maintext">审核状态:</div>
            <el-select
              class="elinput"
              v-model="queryParams.status"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div class="contain">
            <div class="maintext">考勤日期:</div>
            <el-date-picker
              v-model="timevalue"
              type="datetimerange"
              range-separator="--"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="right">
          <el-button type="primary" @click="search" style="background: #3d84ff">
            查询
          </el-button>
          <el-button type="primary" @click="newadd" style="background: #3d84ff">
            新增
          </el-button>
          <el-button type="info" @click="reset"> 重置 </el-button>
          <!-- <el-button class="bt searchbt" @click="search"> 查询 </el-button> 
          <el-button class="bt restbt" @click="reset"> 重置 </el-button> 
          <el-button class="bt" @click="newadd"> 新增 </el-button> -->
        </div>
      </div>
      <div class="main-contain">
        <div class="contain">
          <el-table
            ref="singleTable"
            :data="tableData"
            highlight-current-row
            style="width: 100%"
            class="Table"
            :header-cell-style="{
              'font-size': '15px',
              color: '#666666',
              'font-weight': 'bold',
              background: '#F7F7F7',
            }"
            :row-style="{
              'font-size': '15px',
              color: '#222222',
              'font-weight': '400',
            }"
          >
            <el-table-column prop="created_at" label="申请日期">
              <template slot-scope="scope">
                {{ scope.row.created_at | dataformat }}
              </template>
            </el-table-column>
            <el-table-column label="请假时间">
              <template slot-scope="scope">
                {{ scope.row.start_time | dataformat }} ~
                {{ scope.row.end_time | dataformat }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="审核状态">
              <template slot-scope="scope">
                {{ scope.row.status | statusformat }}
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="item-right">
                  <div class="bt" @click="checkbt(scope.row)">查看</div>
                  <div class="line2"></div>
                  <div class="bt" @click="revisebt(scope.row)">修改</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="elpagination">
            <div class="elpagination-title">共{{ total }}条</div>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="queryParams.per_page"
              :current-page="queryParams.page"
              @current-change="pageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Customdialog
      class="customdialog"
      ref="customdialog"
      type="min"
      width="700px"
      title="请假查看"
      :showclose="true"
    >
      <div slot="dialogbody" class="dialogbody" v-if="infoData">
        <div class="text">实习计划： {{ infoData.plan_name }}</div>
        <div class="text">类型： {{ infoData.status | statusformat }}</div>
        <div class="text">
          时间： {{ infoData.start_time | dataformat }} ~
          {{ infoData.end_time | dataformat }}
        </div>
        <div class="text">原因： {{ infoData.reason }}</div>
        <!-- 目前后端储存数据地址在调整,设计附件上传以及下载的部分都进行隐藏 v-if="false" -->
        <template v-if="Array.isArray(infoData.file)">
          <div class="downbt bt">附件：</div>
          <div
            class="downbt"
            v-for="(item, index) in infoData.file"
            :key="index"
          >
            <div class="file">
              <!-- <el-image class="image" :src="fileIcon(item.ext)" fit="contain" /> -->
              <el-button type="text" class="name" @click="fileView(item)" >{{ item.name }}</el-button>
            </div>
            <el-image class="elimage" :src="icon1" @click="fileView(item)" />
            <el-image
              class="elimage"
              :src="icon2"
              @click="fileDownload(item)"
            />
          </div>
        </template>
        <template v-else>
          <div class="downbt bt">附件：</div>
          <div class="downbt_name">{{ infoData.file }}</div>
        </template>
      </div>
      <div slot="dialogfooter" class="dialogfooter"></div>
    </Customdialog>
    <el-dialog
      :visible.sync="innerVisible"
      title="预览"
      width="80%"
      append-to-body
      :before-close="closeDialog"
    >
      <template v-if="type == '视频'">
        <video
          class="video_view"
          ref="vueRef"
          :src="videoviewurl"
          controls
          controlslist="nodownload noplaybackrate"
          disablepictureinpicture
          @contextmenu.prevent="handleRMouse"
          width="100%"
          height="500"
        />
      </template>
      <template v-if="type == '图片'">
        <iframe
          class="iframe_cont"
          :src="imageviewurl"
          frameborder="0"
          ref="myiframe"
        ></iframe>
      </template>
      <template v-if="type == '其他'">
        <!-- <div class="tip_con">
            <div class="icon">!</div>
            <div class="tip_tex">
              <p v-show="is_private==0">该文件暂时不支持在线预览，您可以下载后查看！</p>
              <p v-show="is_private!=0">该文件暂时不支持在线预览！</p>
            </div>
          </div>-->
        <iframe
          class="iframe_cont"
          :src="file_url"
          frameborder="0"
          ref="myiframe"
        ></iframe>
      </template>
      <template v-if="type == 'PDF'">
        <!-- <div class="pdf_con">
            <md-contract :url="fileurl" :visible="contractVisable" :showBtns="true" @handleModal="close"></md-contract>
          </div>-->
        <iframe
          class="iframe_cont"
          :src="fileurl"
          frameborder="0"
          ref="myiframe"
        ></iframe>
      </template>
      <div
        id="toolbar"
        :class="toolbar == false ? 'tool-box doc_1' : 'tool-box'"
        style="visibility: visible"
      >
        <div class="line-bar1"></div>
        <div class="full-box" style="text-align: right">
          <a class="full-btn1" @click="screen">
            <i class="el-icon-full-screen" style="font-size: 17px" />
            <span style="margin-left: 4px">全屏</span>
          </a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Customdialog from "@/components/customdialog.vue";
import {
  getpracticeleavelist,
  getpracticeleaveinfo,
} from "@/api/practiceleave";
import dayjs from "dayjs";
import { Base64 } from "js-base64";
import screenfull from "screenfull";
const statusmap = ["待审核", "已驳回", "已同意"];

export default {
  name: "mainpage",
  components: {
    Customdialog,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        practice_plan_id: "",
        star_time: "",
        end_time: "",
        status: "",
        page: 1,
        per_page: 10,
      },
      tableData: [], // 表格数据
      total: 0, // 总页数
      options: [
        { value: 0, label: "待审核" },
        { value: 1, label: "已驳回" },
        { value: 2, label: "已同意" },
      ],
      timevalue: "", // 时间段
      infoData: {},

      icon1: require("@/assets/查看.png"),
      icon2: require("@/assets/下载.png"),
      filePreview: "", // 数据预览
      picturesPreview: "", // 多图预览
      fileTask: "", // 数据预埋
      type: "",
      is_private: "",
      videoviewurl: "",
      imageviewurl: "",
      imageviewurlList: [], // 图片数据
      isImg: ["jpg", "png", "jpeg", "gif", "webp"],
      isVideo: ["mp4", "avi", "flv"],
      fileicon1: require("@/assets/fileicon/files.png"),
      fileicon2: require("@/assets/fileicon/icon-PDF.png"),
      fileicon3: require("@/assets/fileicon/icon-word.png"),
      fileicon4: require("@/assets/fileicon/icon-video.png"),
      fileicon5: require("@/assets/fileicon/icon-img.png"),
      fileicon6: require("@/assets/fileicon/icon-node.png"),
      fileicon7: require("@/assets/fileicon/icon-audio.png"),
      fileicon8: require("@/assets/fileicon/icon-chapter.png"),
      fileicon9: require("@/assets/fileicon/rar.png"),
      fileicon10: require("@/assets/fileicon/single.png"),
      fileicon11: require("@/assets/fileicon/txt.png"),
      fileicon12: require("@/assets/fileicon/xlsx.png"),
      fileicon13: require("@/assets/fileicon/zip.png"),
      itemObj: {},
      fullscreen: false, //全屏
      toolbar: false,
      innerVisible: false, // 预览框
    };
  },
  computed: {
    plan_id() {
      return this.$route.query.plan_id;
    },
  },
  created() {
    const systemConfig = sessionStorage.getItem("systemConfig");
    const systemInfo = systemConfig ? JSON.parse(systemConfig) : {};
    if (systemInfo.file_preview_url) {
      this.filePreview = systemInfo.file_preview_url + "/onlinePreview?url="; // 数据预览
      this.picturesPreview =
        systemInfo.file_preview_url + "/picturesPreview?urls="; // 多图预览
      this.fileTask = systemInfo.file_preview_url + "/addTask?url="; // 数据预埋
    } else {
      this.filePreview =
        request_base_path.pro_url + "/file-preview/onlinePreview?url="; // 数据预览
      this.picturesPreview =
        request_base_path.pro_url + "/file-preview/picturesPreview?urls="; // 多图预览
      this.fileTask = request_base_path.pro_url + "/file-preview/addTask?url="; // 数据预埋
    }
    this.queryParams.practice_plan_id = this.plan_id;
    this.getpracticeleavelist();
  },
  filters: {
    statusformat(val) {
      return statusmap[val];
    },
    dataformat(value) {
      if (!value) return "";
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    // 获取列表数据
    getpracticeleavelist() {
      this.tableData = []; // 清空数据
      let params = this.queryParams;
      getpracticeleavelist(params)
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.tableData = res.data.data;
            this.total = res.data.total;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    // 分页切换
    pageChange(val) {
      this.queryParams.page = val;
      this.getpracticeleavelist();
    },
    // 重置
    reset() {
      this.queryParams.star_time = "";
      this.queryParams.end_time = "";
      this.timevalue = "";
      this.queryParams.status = "";
      this.getpracticeleavelist();
    },
    // 查询
    search() {
      if (this.timevalue && this.timevalue.length > 0) {
        if (this.timevalue[0]) {
          this.queryParams.star_time = dayjs(this.timevalue[0]).unix();
        }
        if (this.timevalue[1]) {
          this.queryParams.end_time = dayjs(this.timevalue[1]).unix();
        }
      } else {
        this.queryParams.star_time = "";
        this.queryParams.end_time = "";
      }

      this.getpracticeleavelist();
    },
    // 添加
    newadd() {
      this.$router.push({
        path: "/home/personalcenter/newleave",
        query: {
          plan_id: this.plan_id,
        },
      });
    },
    // 返回
    toback() {
      this.$router.push({
        path: "/home/personalcenter/mainpage",
        query: {
          id: 6,
          componentId: "Myinternship",
        },
      });
    },
    // 查看
    checkbt(item) {
      this.getpracticeleaveinfo({ id: item.id });
      this.$refs.customdialog.dialogopenbt();
    },
    // 详情
    getpracticeleaveinfo(params) {
      this.infoData = [];
      getpracticeleaveinfo(params).then((res) => {
        if (res.code === 0) {
          this.infoData = res.data;
          const files = res.data.file || [];
          files.forEach(element => {
            if (this.isImg.includes(element.ext)) {
              this.imageviewurlList.push(element.url)
            };
          });
        }
      }).catch(() => {});
    },
    // 修改
    revisebt(item) {
      this.$router.push({
        path: "/home/personalcenter/newleave",
        query: {
          id: item.id,
          type: "edit",
          plan_id: this.plan_id,
        },
      });
    },

    fileIcon(val) {
      switch (val) {
        case "file":
          return this.fileicon1;

        case "pdf":
          return this.fileicon2;

        case ("word", "docx"):
          return this.fileicon3;

        case "mp4":
          return this.fileicon4;

        case ("png", "jpg"):
          return this.fileicon5;

        case "radio":
          return this.fileicon7;

        case "rar":
          return this.fileicon9;

        case "txt":
          return this.fileicon11;

        case "xlsx":
          return this.fileicon12;

        case "zip":
          return this.fileicon13;

        default:
          return this.fileicon10;
      }
    },
    async fileView(item) {
      this.resetFill();
      await this.getTask(item.url);
      this.is_private = item.is_private;
      if (this.isVideo.includes(item.ext)) {
        this.type = "视频";
        this.videoviewurl = item.url;
        this.toolbar = false;
      } else if (this.isImg.includes(item.ext)) {
        this.type = "图片";
        let len = this.imageviewurlList.length;
        for (let i = 0; i < this.imageviewurlList.length; i++) {
          if (this.imageviewurlList[i] == item.url) {
            let newArr = this.imageviewurlList.splice(i, len - i);
            let oldArr = this.imageviewurlList;
            this.imageviewurlList = [...newArr, ...oldArr];
            break;
          }
        }
        let url = this.imageviewurlList.join("|");
        this.imageviewurl = this.picturesPreview + encodeURIComponent(Base64.encode(url));
        this.toolbar = true;
      } else if (item.ext == "pdf") {
        this.type = "PDF";
        this.fileurl =
          this.filePreview + encodeURIComponent(Base64.encode(item.url));
        this.toolbar = true;
      } else {
        this.type = "其他";
        this.file_url =
          this.filePreview + encodeURIComponent(Base64.encode(item.url));
        this.toolbar = true;
      }
      this.itemObj = item;
      this.innerVisible = true;
    },
    resetFill() {
      this.imageviewurl = "";
      this.fileurl = "";
      this.file_url = "";
    },
    getTask(data) {
      this.fileTask + data;
    },
    closeDialog() {
      this.innerVisible = false;
      this.resetFill();
    },
    //全屏
    screen() {
      if (screenfull.isEnabled) {
        screenfull.toggle(this.$refs.myiframe);
      }
    },
    fileDownload(item) {
      const downloadElement = document.createElement("a");
      downloadElement.download = item.name; //设置下载的名称
      downloadElement.href = item.url; // 创建下载的链接
      downloadElement.style.display = "none"; // 隐藏的可下载链接
      document.body.appendChild(downloadElement); // 创建虚拟下载元素
      downloadElement.target = "_blank";
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },
  },
};
</script>
<style scoped lang="scss">
.mainpage {
  min-height: calc(100vh - 240px);
  background: #fff;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    padding-top: 10px;
    .head-title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #3d84ff;
      user-select: none;
      white-space: nowrap;
    }
    .retutnbt {
      width: 64px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      background: #3d84ff;
      border-radius: 4px;
      color: white;
      user-select: none;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .line {
    margin-top: 14px;
    margin-bottom: 4px;
    border-bottom: 2px solid #cccccc;
  }
  .maincontain {
    border-radius: 4px;
    padding: 20px 20px 0;

    .searchcontain {
      height: 56px;
      padding: 0 20px;
      background: #fcfcfc;
      border: 1px solid #ececec;
      margin-top: 20px;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .contain {
          margin-right: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .maintext {
            margin-right: 10px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #888888;
          }
          .elinput {
            width: 200px;
            ::v-deep .el-input__suffix {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
      .right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .bt {
          width: 64px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          background: #3d84ff;
          color: white;
          padding: 0px;
        }
        .restbt {
          margin-right: 10px;
          background: white;
          color: #3d84ff;
        }
      }
    }
    .main-contain {
      margin-top: 20px;
      width: 100%;
      .contain {
        width: 100%;
        height: 100%;
        .Table {
          width: 100%;
          .item-left {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .title {
              margin-left: 10px;
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #222222;
            }
          }
          .item-middle {
            .title {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #222222;
            }
          }

          .item-right {
            display: flex;
            justify-content: center;
            align-items: center;
            .bt {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #0773fc;
              user-select: none;
              cursor: pointer;
            }
            .line2 {
              margin-right: 8px;
              margin-left: 8px;
              height: 14px;
              border-right: 2px solid #cccccc;
            }
          }
        }
        .elpagination {
          margin-top: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          .elpagination-title {
            margin-right: 4px;
          }
        }
      }
    }
  }
  .customdialog {
    .dialogbody {
      padding: 40px;
      .text {
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        color: #222222;
      }
      .downbt {
        margin-top: 30px;
        // margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        
        .downbt {
          margin-top: 15px;
          margin-left: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          line-height: 35px;
          .file {
            display: flex;
            align-items: center;
            .image {
              width: 30px;
              height: 30px;
              margin: 5px;
            }
          }

          .elimage {
            margin-left: 10px;
            cursor: pointer;
            top: 13px;
            width: 15px;
          }

          .downbt_name {
            color: #3d84ff;
          }
        }
        
        .elimage {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .mainpage {
    .head {
      margin-top: 66px;
      .retutnbt {
        margin-right: 10px;
      }
    }
    .maincontain {
      padding-top: 0px;

      .searchcontain {
        height: auto;
        padding: 10px;
        .left {
          // display: flex;
          // justify-content: flex-start;
          // align-items: center;
          .contain {
            // margin-right: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
            .maintext {
              // margin-right: 10px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #888888;
              width: 30%;
            }
            .elinput {
              width: 100%;
              ::v-deep .el-input__suffix {
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }
        }
        .right {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .bt {
            width: 64px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            background: #3d84ff;
            color: white;
            padding: 0px;
          }
          .restbt {
            margin-right: 10px;
            background: white;
            color: #3d84ff;
          }
        }
      }
      .main-contain {
        margin-top: 20px;
        width: 100%;
        .contain {
          width: 100%;
          height: 100%;
          .Table {
            width: 100%;
            .item-left {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .title {
                margin-left: 10px;
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #222222;
              }
            }
            .item-middle {
              .title {
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #222222;
              }
            }

            .item-right {
              display: flex;
              justify-content: center;
              align-items: center;
              .bt {
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #0773fc;
                user-select: none;
                cursor: pointer;
              }
              .line2 {
                margin-right: 8px;
                margin-left: 8px;
                height: 14px;
                border-right: 2px solid #cccccc;
              }
            }
          }
          .elpagination {
            margin-top: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            .elpagination-title {
              margin-right: 4px;
            }
          }
        }
      }
    }
    .customdialog {
      .dialogbody {
        padding: 40px;
        .text {
          font-size: 16px;
          font-weight: 400;
          line-height: 30px;
          color: #222222;
        }
        .downbt {
          margin-top: 30px;
          // margin-left: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .elimage {
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 640px) and (max-width: 1200px) {
  .mainpage {
    .head {
      margin-top: 30px;
      .retutnbt {
        margin-right: 40px;
      }
    }
    .maincontain {
      .searchcontain {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .mainpage {
    .head {
      margin-top: 30px;
      .retutnbt {
        margin-right: 40px;
      }
    }
    .maincontain {
      .searchcontain {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
